import React from 'react';
import { Link } from 'react-router-dom';
import appInfo from '../../app-info';
import './Footer.scss';

export default function Footer() {
  const mainTitle = appInfo.title.replace('®', '');
  return (
    <footer>
      <div className="footer-toolbar flex lg:flex-row sm:flex-row md:flex-row flex-col space-y-3 lg:space-y-0 items-center justify-center">
        <div>
          All rights reserved - {new Date().getFullYear()} <span>{mainTitle}<sup className="ms-[2px]">®</sup>𝑖QMS</span>
        </div>
        {/* <div>
          <Link to="/tasks" style={{ textDecoration: 'none', color: 'inherit' }}>
            Report Issue
          </Link>
          <span style={{ padding: '0 16px' }}>|</span>
          <Link to="/tasks" style={{ textDecoration: 'none', color: 'inherit' }}>
            Contact Support
          </Link>
        </div> */}
      </div>
    </footer>
  );
}
